/* ======================================================================
   МОДУЛЬ HISTORY-ROUTER: БЕСШОВНАЯ SPA НАВИГАЦИЯ И ИНТЕРАКТИВНЫЕ ЭЛЕМЕНТЫ
   ====================================================================== */

let isNavigating = false;

async function spaNavigate(targetUrl, push = true, isPop = false) {
  if (isNavigating) return;
  try {
    let urlObj;
    try {
      urlObj = new URL(targetUrl, window.location.href);
    } catch (e) {
      window.location.href = targetUrl;
      return;
    }

    if (!urlObj.search && window.location.search) {
      urlObj.search = window.location.search;
    }

    const fullUrl = urlObj.pathname + urlObj.search + urlObj.hash;

    const isProtectedTarget = urlObj.pathname.includes('dashboard') ||
                              urlObj.pathname.includes('day-') ||
                              urlObj.pathname.includes('questionnaire') ||
                              urlObj.pathname.includes('referral') ||
                              urlObj.pathname.includes('course-tariffs');

    if (typeof isRegistered === 'function' && !isRegistered() && isProtectedTarget) {
      if (typeof openModal === 'function') {
        openModal(fullUrl);
      } else if (typeof window.openModal === 'function') {
        window.openModal(fullUrl);
      }
      return;
    }

    if (!isPop && urlObj.pathname === window.location.pathname && urlObj.search === window.location.search && !urlObj.hash) {
      return;
    }

    isNavigating = true;

    const res = await fetch(fullUrl, { cache: 'no-cache' });
    if (!res.ok) {
      console.error('[SPA] Fetch failed with status:', res.status);
      alert('Ошибка загрузки страницы. Пожалуйста, перезапустите приложение.');
      return;
    }

    const htmlText = await res.text();
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(htmlText, 'text/html');

    const newContainer = newDoc.querySelector('.app-container');
    const oldContainer = document.querySelector('.app-container');

    if (!newContainer || !oldContainer) {
      console.error('[SPA] Missing app-container');
      alert('Ошибка структуры страницы. Пожалуйста, перезапустите приложение.');
      return;
    }

    oldContainer.replaceWith(newContainer);

    document.querySelectorAll('style[data-spa-injected]').forEach(el => el.remove());
    newDoc.querySelectorAll('head style').forEach(st => {
      const newStyle = document.createElement('style');
      newStyle.setAttribute('data-spa-injected', 'true');
      newStyle.textContent = st.textContent;
      document.head.appendChild(newStyle);
    });

    if (newDoc.title) {
      document.title = newDoc.title;
    }

    if (push) {
      history.pushState({ spaUrl: fullUrl }, '', fullUrl);
    } else if (!isPop) {
      history.replaceState({ spaUrl: fullUrl }, '', fullUrl);
    }

    // Яндекс.Метрика: виртуальный хит при SPA переходе
    try {
      const counterId = window.YM_COUNTER_ID || localStorage.getItem('meta_ym_counter_id');
      if (typeof window.ym === 'function' && counterId && counterId !== '00000000') {
        window.ym(Number(counterId), 'hit', fullUrl, {
          title: document.title,
          referer: window.location.href
        });
      }
    } catch (e) {}

    window.scrollTo(0, 0);

    newDoc.querySelectorAll('script:not([src])').forEach(sc => {
      const code = sc.textContent.trim();
      if (code) {
        try {
          (new Function(code))();
        } catch (err) {
          console.warn('[SPA] Inline script execution note:', err);
        }
      }
    });

    bindPageInteractions();
    updateBonusUI();
    updateReferralUI();
    updateDayPageUI(fullUrl);
    if (typeof initVideoTracking === 'function') {
      setTimeout(initVideoTracking, 100);
    }
    applyAdminSettings(fullUrl);
    updateLandingCTA();
    updateHeaderNav();
    updateTelegramBackButton(fullUrl);
    if (fullUrl.includes('dashboard.html')) {
      updateDashboardUI(getUser());
    }
    syncProfileWithServer();

  } catch (err) {
    console.warn('[SPA] Fallback to standard navigation:', err);
    console.error('[SPA] Fatal error during navigation:', err);
    alert('Сбой навигации. Пожалуйста, перезапустите приложение.');
  } finally {
    isNavigating = false;
  }
}

function bindPageInteractions() {
  const currentPath = window.location.pathname;
  const isDashboardPage = currentPath.endsWith('dashboard.html') || currentPath.endsWith('dashboard');

  // 1. Аккордеон карточек программы (лендинг) и эфиров (кабинет)
  window.toggleAccordionCard = function(headerOrCard) {
    if (!headerOrCard) return;
    const card = headerOrCard.classList.contains('program-card') || headerOrCard.classList.contains('day-item-card')
      ? headerOrCard
      : headerOrCard.closest('.program-card, .day-item-card');
    if (!card) return;

    const wasActive = card.classList.contains('active');
    const stack = card.closest('.program-stack, .days-stack') || card.parentElement;
    if (stack) {
      stack.querySelectorAll('.program-card, .day-item-card').forEach(c => c.classList.remove('active'));
    }
    if (!wasActive) {
      card.classList.add('active');
    }
    try { triggerHaptic('light'); } catch (e) {}
  };

  document.querySelectorAll('.day-card-header, .program-header').forEach(header => {
    header.onclick = function(e) {
      if (e && e.target && e.target.closest('button, a, input, select')) return;
      window.toggleAccordionCard(this);
    };
  });

  // 2. Активные вкладки нижней панели
  if (typeof updateBottomNavForDay4 === 'function') {
    updateBottomNavForDay4();
  }

  document.querySelectorAll('.bottom-nav-item').forEach(item => {
    const href = item.getAttribute('href') || '';
    item.classList.remove('active');
    const svg = item.querySelector('svg');
    if (svg) {
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
    }

    const isCurDash = currentPath.includes('dashboard');
    const isCurRef = currentPath.includes('referral');
    const isCurTariffs = currentPath.includes('course-tariffs');
    const isCurHome = (currentPath === '/' || currentPath.includes('landing') || currentPath.includes('index'));

    if ((isCurDash && href.includes('dashboard')) ||
        (isCurRef && href.includes('referral')) ||
        (isCurTariffs && href.includes('course-tariffs')) ||
        (isCurHome && (href.includes('landing') || href === '/'))) {
      item.classList.add('active');
      if (svg) {
        svg.setAttribute('fill', 'currentColor');
        svg.setAttribute('stroke', 'none');
      }
    }
  });

  updateLandingCTA();
  updateHeaderNav();
  applyAdminSettings();
  updateBonusUI();
  updateReferralUI();
  updateDayPageUI();
  if (isDashboardPage) {
    updateDashboardUI(getUser());
  }
  initTelegramBackButton();

  // 3. Статусы выполнения эфиров
  let activeDayNum = null;
  if (currentPath.includes('day-1')) activeDayNum = 1;
  else if (currentPath.includes('day-2')) activeDayNum = 2;
  else if (currentPath.includes('day-3')) activeDayNum = 3;
  else if (currentPath.includes('day-4')) activeDayNum = 4;

  if (activeDayNum) {
    if (localStorage.getItem(`meta_day_${activeDayNum}_completed`) === 'true') {
      const btn = document.getElementById('markCompletedBtn');
      const badge = document.getElementById('completedBadge');
      if (btn && badge) {
        btn.style.display = 'none';
        badge.style.display = 'block';
      }
    }
  }

  // 4. Анкета предзаписи
  const questForm = document.getElementById('questForm');
  if (questForm && !questForm.dataset.bound) {
    questForm.dataset.bound = 'true';
    questForm.addEventListener('submit', function(e) {
      if (typeof window.handleFormSubmit === 'function') {
        return window.handleFormSubmit(e);
      }
    });
    const questSubmitBtn = document.getElementById('questSubmitBtn');
    if (questSubmitBtn && !questSubmitBtn.dataset.bound) {
      questSubmitBtn.dataset.bound = 'true';
      questSubmitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof window.handleFormSubmit === 'function') {
          return window.handleFormSubmit(e);
        }
      });
    }
    try {
      const u = getUser() || {};
      const q1 = document.getElementById('q1');
      const q7 = document.getElementById('q7');
      if (q1 && u.name && !q1.value) q1.value = u.name;
      if (q7 && !q7.value) q7.value = u.phone || (u.username ? '@' + u.username.replace('@', '') : '');
    } catch (e) {}
  }

  // 5. Кнопка отметки о прохождении эфира
  const markBtn = document.getElementById('markCompletedBtn');
  if (markBtn && !markBtn.dataset.bound) {
    markBtn.dataset.bound = 'true';
    markBtn.addEventListener('click', () => {
      if (typeof window.toggleCompleted === 'function') {
        window.toggleCompleted();
      }
    });
  }

  if (isRegistered()) {
    document.documentElement.classList.remove('meta-auth-checking');
  }
}

// Хелперы копирования ссылок
window.copyReferralLink = function() {
  const link = getReferralLink();
  copyToClipboard(link).then(() => {
    showToast('✓ Персональная ссылка скопирована!');
    const btn = document.getElementById('copyRefBtn');
    if (btn) {
      btn.textContent = '✓';
      setTimeout(() => btn.textContent = '📋', 2000);
    }
  }).catch(() => {
    showToast('Выделите и скопируйте ссылку вручную');
  });
};

window.copyPersonalLink = function(btn) {
  const link = getReferralLink();
  copyToClipboard(link).then(() => {
    showToast('✓ Персональная ссылка скопирована!');
    if (btn) {
      const oldText = btn.innerHTML;
      btn.textContent = '✓ Ссылка скопирована!';
      setTimeout(() => btn.innerHTML = oldText, 2500);
    }
  }).catch(() => {
    showToast('Выделите и скопируйте ссылку вручную');
  });
};

// Главная инициализация приложения
function init() {
  try { syncSettingsWithBackend(); } catch (e) {}

  try {
    updateDayPageUI();
    if (typeof updateLandingProgramUI === 'function') {
      updateLandingProgramUI();
    }
    if (typeof initVideoTracking === 'function') {
      setTimeout(initVideoTracking, 100);
    }
  } catch (e) {}

  const tg = window.Telegram?.WebApp;
  if (tg) {
    try {
      tg.ready();
      tg.expand();
      if (typeof tg.disableVerticalSwipes === 'function') tg.disableVerticalSwipes();
      if (typeof tg.enableClosingConfirmation === 'function') tg.enableClosingConfirmation();
      if (typeof tg.setHeaderColor === 'function') tg.setHeaderColor('#F7F4EE');
      if (typeof tg.setBackgroundColor === 'function') tg.setBackgroundColor('#F7F4EE');
      if (!isRegistered()) requestBotWriteAccess();
    } catch (e) {}
  }

  initTelegramBackButton();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button, .btn-emerald, .btn-main, .btn-copy, .btn-copy-link, .btn-copy-mini, .program-header, .day-card-header, .bottom-nav-item');
    if (btn) triggerHaptic('light');
  });

  // Перехват кликов по внутренним ссылкам
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href) return;

    if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

    if (href.includes('://') && !href.startsWith(window.location.origin)) {
      if (window.Telegram?.WebApp) {
        e.preventDefault();
        e.stopPropagation();
        openExternalLink(href);
      }
      return;
    }

    let targetUrl;
    try {
      targetUrl = new URL(href, window.location.href);
    } catch (err) {
      return;
    }

    if (targetUrl.origin === window.location.origin) {
      if (targetUrl.pathname.includes('admin') || targetUrl.pathname.endsWith('.pdf') || targetUrl.pathname.endsWith('.zip')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      const isProtectedTarget = targetUrl.pathname.includes('dashboard') ||
                                targetUrl.pathname.includes('day-') ||
                                targetUrl.pathname.includes('questionnaire') ||
                                targetUrl.pathname.includes('referral') ||
                                targetUrl.pathname.includes('course-tariffs');

      if (typeof isRegistered === 'function' && !isRegistered() && isProtectedTarget) {
        try { triggerHaptic('light'); } catch (err) {}
        if (typeof openModal === 'function') {
          openModal(targetUrl.pathname + targetUrl.search + targetUrl.hash);
        } else if (typeof window.openModal === 'function') {
          window.openModal(targetUrl.pathname + targetUrl.search + targetUrl.hash);
        }
        return;
      }

      spaNavigate(targetUrl.pathname + targetUrl.search + targetUrl.hash, true);
    }
  }, true);

  window.addEventListener('popstate', () => {
    const fullUrl = window.location.pathname + window.location.search + window.location.hash;
    spaNavigate(fullUrl, false, true);
  });

  const currentPath = window.location.pathname;
  if (handleDeeplinksAndHash(currentPath)) {
    return;
  }

  updateLandingCTA();
  updateHeaderNav();
  updateTelegramBackButton();
  applyAdminSettings();
  updateBonusUI();
  bindPageInteractions();

  const syncPromise = syncProfileWithServer();
  checkStartParamPayment();
  updateReferralUI();
  initAdminSecretGesture();

  handleNavigationGuard(currentPath, syncPromise);
}

window.spaNavigate = spaNavigate;
window.bindPageInteractions = bindPageInteractions;
window.init = init;